export default __webpack_public_path__ + "static/media/footer-pin.deb4e0b6.svg";